/*
 * @Author: haiifeng
 * @Date: 2019-07-16 10:17:18
 * @LastEditors: haiifeng
 * @LastEditTime: 2020-11-19 13:56:01
 * @FilePath: \code\cms_resouce\xdf_pc_www\src\api\js\home\applications.js
 */
// 应用新秀
export const applications = [{
    imgUrl: 'http://file.xdf.cn/uploads/191127/1368_20191127162533.png',
    name: '新东方app',
    url: 'https://ppss.xdf.cn/h5/3-download/download.html',
    intro: '中小学一站式学习服务平台'
  },{
    imgUrl: 'http://file.xdf.cn/uploads/191127/1368_20191127162617.png',
    name: '新东方好老师',
    url: 'https://fir.im/woxue',
    intro: '新东方老师的办公利器'
  },
  {
    imgUrl: 'http://file.xdf.cn/uploads/191127/1368_20191127162801.png',
    name: '新东方云学习',
    url: 'https://apps.apple.com/cn/app/%E6%96%B0%E4%B8%9C%E6%96%B9%E4%BA%91%E5%AD%A6%E4%B9%A0/id1473927792',
    intro: '线上智能化学习平台'
  },
  {
    imgUrl: 'http://file.xdf.cn/uploads/201118/1368_20201118160707.png',
    name: '新东方乐听说',
    url: 'https://datayi.cn/o35RyL9',
    intro: '英语听力口语AI教练'
  },
  // {
  //   imgUrl: 'http://file.xdf.cn/uploads/171011/145_171011100630moPopJOBClc94MKk.jpg',
  //   name: '爱说口语',
  //   url: 'https://itunes.apple.com/cn/app/qq-yin-le-ting-gek-gefm-dian/id1074241367?mt=8',
  //   intro: '让你爱上说口语'
  // },
  {
    imgUrl: 'http://file.xdf.cn/uploads/191127/1368_20191127165310.png',
    name: '新东方乐词',
    url: 'https://sj.qq.com/myapp/detail.htm?apkName=com.xdf.recite',
    intro: '考试学词，只用乐词'
  },
  // {
  //   imgUrl: 'http://file.xdf.cn/uploads/191127/1368_20191127165250.png',
  //   name: '新东方乐听',
  //   url: 'https://sj.qq.com/myapp/detail.htm?apkName=com.ileci.LeListening',
  //   intro: '学听力 用乐听 乐享其成'
  // },
  // {
  //   imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/app/wexz.png',
  //   name: '威尔小镇',
  //   url: 'http://fir.im/w21g?utm_source=fir&utm_medium=qr',
  //   intro: '学前儿童家庭教育指南'
  // },
  // {
  //   imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/app/liuxue.png',
  //   name: '新东方留学考试',
  //   url: 'http://il.xdf.cn/ITS/apps/down/Installer.html',
  //   intro: '新东方留学考试互动学习平台APP'
  // },
  {
    imgUrl: 'http://file.xdf.cn/uploads/210202/1368_20210202110048.png',
    name: '新东方小书童',
    url: 'https://plus.readingpro.cn/weixin/thirdPages/appDownload.html',
    intro: '培养一生的阅读习惯 '
  },
  {
    imgUrl: 'http://file.xdf.cn/uploads/210804/1368_20210804103355.jpg',
    name: '新东方出国考试',
    url: 'https://un.koolearn.com/alliance/clickword?userid=21efd750fcc144cba58bdc8a16d093c5&kid=ee41bf9cfd76496390e68a8270bd0cfa&url=https%3A%2F%2Fliuxue.koolearn.com%2Fdownload%2Fchuguo%2Fxdf-pc-app%2F&utm_source=baidu&utm_medium=pcss&utm_campaign=%E9%9B%86%E5%9B%A2%E9%A6%96%E9%A1%B5&utm_content=%E5%BA%94%E7%94%A8%E6%96%B0%E7%A7%80&utm_term=%E5%87%BA%E5%9B%BD%E8%80%83%E8%AF%95app',
    intro: '出国留学备考练习利器 '
  },


]



// WEBPACK FOOTER //
// ./src/api/js/home/applications.js